import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createVNode as _createVNode, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "d-sm-flex align-items-center" }
const _hoisted_5 = ["value", "id"]
const _hoisted_6 = ["for"]
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = {
  key: 0,
  class: "col"
}
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = { class: "table-responsive" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_21 = { class: "skeleton" }
const _hoisted_22 = {
  key: 1,
  class: "table text-nowrap align-middle mb-0"
}
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_26 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_27 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_29 = {
  key: 0,
  class: "badge text-outline-danger"
}
const _hoisted_30 = {
  key: 1,
  class: "badge text-outline-primary"
}
const _hoisted_31 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_32 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_33 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_34 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_35 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_36 = { class: "shadow-none lh-1 fw-medium text-end pe-0 sm" }
const _hoisted_37 = { class: "dropdown" }
const _hoisted_38 = { class: "dropdown-menu" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }
const _hoisted_42 = {
  class: "modal fade createNewModal",
  id: "Resiliation",
  tabindex: "-1",
  ref: "ResiliationRef",
  "aria-hidden": "true"
}
const _hoisted_43 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_44 = { class: "modal-content p-15 p-md-40" }
const _hoisted_45 = { class: "modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-md-12" }
const _hoisted_48 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_49 = {
  class: "modal fade createNewModal",
  id: "ValideAbonnementModal",
  tabindex: "-1",
  ref: "addValidAbonnementModalRef",
  "aria-hidden": "true"
}
const _hoisted_50 = {
  class: "modal-dialog modal-dialog-centered",
  style: {"width":"100%","max-width":"450px"}
}
const _hoisted_51 = { class: "modal-content p-15 p-md-40" }
const _hoisted_52 = { class: "modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25" }
const _hoisted_53 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.checkPermission('AddAbonnement'))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
                to: "/ajouter-abonnement"
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1),
                  _createTextVNode(" Ajouter un abonnement ", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listeEtats, (etat, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "form-check me-4"
            }, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input shadow-none",
                type: "radio",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedEtat) = $event)),
                value: index,
                name: "flexRadioDefault",
                id: 'option' + index
              }, null, 8, _hoisted_5), [
                [_vModelRadio, _ctx.selectedEtat]
              ]),
              _createElementVNode("label", {
                class: "form-check-label fw-medium",
                for: 'flexRadioDefault' + index
              }, _toDisplayString(etat), 9, _hoisted_6)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Mot clé ", -1)),
                _createVNode(_component_Field, {
                  style: {"max-height":"42px"},
                  modelValue: _ctx.searchTerm,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchTerm) = $event)),
                  onKeyup: _ctx.rechercher,
                  name: "mot",
                  type: "text",
                  "aria-disabled": "true",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Recherche par mot clé"
                }, null, 8, ["modelValue", "onKeyup"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Modele de boîte "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  modelValue: _ctx._modeleBoite,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx._modeleBoite) = $event)),
                  name: "modeleBoite"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.modeleOptions,
                      searchable: true
                    }, field, { placeholder: "Sélectionner un modele" }), null, 16, ["options"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "modeleBoite",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Catégorie Abonné "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  modelValue: _ctx._categorieAbonne,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx._categorieAbonne) = $event)),
                  name: "categorieAbonne"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.categorieAbonneOptions,
                      searchable: true,
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, { placeholder: "Sélectionner le type de boîte" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "categorieAbonne",
                  class: "text-danger"
                })
              ])
            ]),
            (!_ctx.etatAgence)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Bureau "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      modelValue: _ctx._bureau,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx._bureau) = $event)),
                      name: "bureau"
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.bureauOptions,
                          searchable: true,
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner un bureau" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "bureau",
                      class: "text-danger"
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _cache[16] || (_cache[16] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("div", _hoisted_18, [
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("table", _hoisted_20, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_21, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, (n) => {
                        return _createElementVNode("th", { key: n }, [...(_cache[11] || (_cache[11] = [
                          _createElementVNode("div", {
                            class: "skeleton",
                            style: {"height":"20px","width":"100%"}
                          }, null, -1)
                        ]))])
                      }), 64))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.limit, (n) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: 'row-'+n
                      }, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, (m) => {
                          return _createElementVNode("td", {
                            key: 'cell-'+m
                          }, [
                            _createElementVNode("div", {
                              class: "skeleton",
                              style: _normalizeStyle({ height: '20px', width: _ctx.randomWidth() })
                            }, null, 4)
                          ])
                        }), 64))
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("table", _hoisted_22, [
                _cache[15] || (_cache[15] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " REFERENCE "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " ABONNE "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Numéro DE BOITE "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " ADRESSE POSTALE "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " TARIF "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " ETAT "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " DATE ABONNEMENT "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " MODELE DE BOITE "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " CATEGORIE ABONNE "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " BUREAU "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " ANNEE IMPAYÉE "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                    }, "Actions")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.abonnements, (abonne, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_23, _toDisplayString(abonne.refAbo), 1),
                      _createElementVNode("td", _hoisted_24, _toDisplayString(abonne.abonne? abonne.abonne.nomComplet : ""), 1),
                      _createElementVNode("td", _hoisted_25, _toDisplayString(abonne.boite?.refBoite), 1),
                      _createElementVNode("td", _hoisted_26, _toDisplayString(abonne.boite?.adressePostale?.adresse_postale), 1),
                      _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.separateur(abonne.loyer)), 1),
                      _createElementVNode("td", _hoisted_28, [
                        (abonne.etat == 'Résilié')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(abonne.etat), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(abonne.etat), 1))
                      ]),
                      _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.format_Date(abonne.dateAbonnement)), 1),
                      _createElementVNode("td", _hoisted_32, _toDisplayString(abonne.boite.modele?.libelle), 1),
                      _createElementVNode("td", _hoisted_33, _toDisplayString((abonne.abonne?.categorieAbonne?.libelle.length > 25) ? abonne.abonne.categorieAbonne?.libelle.substring(0, 25) + '...' : abonne.abonne.categorieAbonne?.libelle), 1),
                      _createElementVNode("td", _hoisted_34, _toDisplayString(abonne.bureau?.nom), 1),
                      _createElementVNode("td", _hoisted_35, _toDisplayString(abonne?.nbMoisImpaye), 1),
                      _createElementVNode("td", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _cache[14] || (_cache[14] = _createElementVNode("span", {
                            class: "badge text-white bg-primary fs-15 dropdown-toggle",
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false"
                          }, [
                            _createTextVNode(" Actions "),
                            _createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
                          ], -1)),
                          _createElementVNode("ul", _hoisted_38, [
                            (_ctx.checkPermission('ViewAbonnement'))
                              ? (_openBlock(), _createElementBlock("li", _hoisted_39, [
                                  _createVNode(_component_router_link, {
                                    to: { name: 'ViewAbonnementPage', params: { id: abonne.id } },
                                    class: "dropdown-item d-flex align-items-center"
                                  }, {
                                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                      _createElementVNode("i", { class: "flaticon-eye lh-1 me-8 position-relative top-1" }, null, -1),
                                      _createTextVNode("Détails ", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["to"])
                                ]))
                              : _createCommentVNode("", true),
                            (abonne.etat == 'En attente' && _ctx.checkPermission('ValidAbonnement'))
                              ? (_openBlock(), _createElementBlock("li", _hoisted_40, [
                                  _createVNode(_component_router_link, {
                                    to: { name: 'ViewAbonnementPage', params: { id: abonne.id } },
                                    class: "dropdown-item d-flex align-items-center"
                                  }, {
                                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                      _createElementVNode("i", { class: "flaticon-check lh-1 me-8 position-relative top-1" }, null, -1),
                                      _createTextVNode("Valider l'abonnement ", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["to"])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_42, [
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25" }, [
            _createElementVNode("h5", { class: "modal-title fw-bold text-black" }, " Résiliation d'office")
          ], -1)),
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_Form, {
              ref: "resiliationForm",
              onSubmit: _ctx.resilier
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _cache[17] || (_cache[17] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                        _createTextVNode(" Motif "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createVNode(_component_Field, {
                        name: "motif",
                        type: "textarea",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Veuillez renseigner le motif"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "motif",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _cache[18] || (_cache[18] = _createElementVNode("button", {
                    class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16",
                    type: "submit"
                  }, " Resilier ", -1))
                ])
              ]),
              _: 1
            }, 8, ["onSubmit"])
          ]),
          _cache[20] || (_cache[20] = _createElementVNode("button", {
            type: "button",
            class: "btn-close shadow-none",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, -1))
        ])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_49, [
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("div", _hoisted_51, [
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25" }, [
            _createElementVNode("h5", { class: "modal-title fw-bold text-black" })
          ], -1)),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _cache[22] || (_cache[22] = _createElementVNode("h5", null, "Vous êtes sur le point de valider l'abonnement: ", -1)),
              _createElementVNode("h5", null, _toDisplayString(_ctx.selectedAbonnement?.refAbo) + " de " + _toDisplayString(_ctx.selectedAbonnement?.abonne?.nomComplet), 1),
              _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("button", {
                class: "btn btn-primary transition border-0 lh-1 fw-medium mr-4",
                type: "submit",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.valideAbonnement()))
              }, " Validez "),
              _createVNode(_component_router_link, {
                to: "#",
                "data-bs-dismiss": "modal",
                class: "ms-3 btn btn-danger transition border-0 lh-1 fw-medium"
              }, {
                default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                  _createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1),
                  _createElementVNode("span", { class: "position-relative" }, null, -1),
                  _createTextVNode("Annuler", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _cache[25] || (_cache[25] = _createElementVNode("button", {
            type: "button",
            class: "btn-close shadow-none",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, -1))
        ])
      ])
    ], 512)
  ], 64))
}